import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IParametrosGeneralesResponse, 
  IParametrosGeneralesRequest 
} from '../interfaces/parametros-generales.interface';

@Injectable({
  providedIn: 'root'
})
export class ParametrosGeneralesService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}ParametrosGenerales/cmspa_paramList`;
  private readonly FECHA_URL = `${environment.apiNewBackBaseUrl}Articulos/cmspa_FechaJulStr`;
  private readonly FECHA_JULIANA_URL = `${environment.apiNewBackBaseUrl}Articulos/cmspa_FechaStrJul`;
  private readonly DELETE_URL = `${environment.apiNewBackBaseUrl}ParametrosGenerales/cmspa_paramDelete`;
  private readonly CHECK_EXISTS_URL = `${environment.apiNewBackBaseUrl}ParametrosGenerales/cmspa_paramNumClte`;
  private readonly SAVE_URL = `${environment.apiNewBackBaseUrl}ParametrosGenerales/cmspa_paramAdd`;
  private readonly UPDATE_URL = `${environment.apiNewBackBaseUrl}ParametrosGenerales/cmspa_paramUpd`;

  constructor(private http: HttpClient) { }

  getParametrosGenerales(request: IParametrosGeneralesRequest): Observable<IParametrosGeneralesResponse> {
    return this.http.post<IParametrosGeneralesResponse>(this.API_URL, request);
  }

  convertirFechaJuliana(fechaEntera: string): Observable<any> {
    const request = { fechaEntera };
    return this.http.post<any>(this.FECHA_URL, request);
  }

  deleteParametrosGenerales(request: IParametrosGeneralesRequest): Observable<any> {
    return this.http.post<any>(this.DELETE_URL, request);
  }

  checkIfExists(request: IParametrosGeneralesRequest): Observable<any> {
    return this.http.post<any>(this.CHECK_EXISTS_URL, request);
  }

  saveParametrosGenerales(request: IParametrosGeneralesRequest): Observable<any> {
    return this.http.post<any>(this.SAVE_URL, request);
  }

  convertirFechaAJuliana(fecha: string): Observable<any> {
    const request = { fecha };
    return this.http.post<any>(this.FECHA_JULIANA_URL, request);
  }

  updateParametrosGenerales(request: IParametrosGeneralesRequest): Observable<any> {
    return this.http.post<any>(this.UPDATE_URL, request);
  }
} 